import { gql } from '@apollo/client'

export default gql`
  query GetAppUserAlerts($sport_id: Int) {
    appUserAlerts(sport_id: $sport_id) {
      ... on OrganizationAlerts {
        total
        my_organizations
        moderation_organizations
        legalentities
      }
    }
  }`
